import DataTable from '../../../components/DataTable/DataTable';
import StateBadge from '../../../components/StatesBadge/StatesBadge';
import { Alert, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getEstadoExpuestoOptions } from '../consts/periodicosTypes';
import StateBadgeConvocated from '../../../components/StatesBadge/SateBadgeConvocated';
import NoTableDataImageBO from '../../../assets/image/empty-state-establecimientos-backoffice.png';

const getFechaContratoBadge = (fechaAlta: string | Date): React.ReactNode => {
    if (!fechaAlta) return '-';

    const fecha = new Date(fechaAlta);
    const hoy = new Date();
    const diffEnMs = hoy.getTime() - fecha.getTime();
    const diffEnDias = Math.floor(diffEnMs / (1000 * 60 * 60 * 24));

    let estado: 'activo' | 'presentado' | 'inactivo' | null = null;

    if (diffEnDias >= 90) {
        estado = 'inactivo';
    } else if (diffEnDias >= 60) {
        estado = 'presentado';
    } else if (diffEnDias >= 30) {
        estado = 'activo';
    }

    return estado ? (
        <StateBadge state={estado} text={fecha.toLocaleDateString()} hideIcon />
    ) : (
        <span>{fecha.toLocaleDateString()}</span>
    );
};

const ExposedGrid = ({
    items,
    filters,
    setFilters,
    isFetching,
    selectedIds,
    handleSelectEmployee,
    handleClickAction,
    showRiesgoError,
    handleSelectAllEmployed,
    tabIndex,
    getUniqueIdByTabIndex,
    getColumnWidths
}: any) => {
    const { t } = useTranslation('periodicos');

    return (
        <>
            {showRiesgoError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {t('alerts.massiveAssignment')}
                </Alert>
            )}
            <DataTable
                columnTitles={[
                    <Checkbox
                        checked={
                            items?.data?.data?.length > 0 &&
                            items?.data?.data?.every((item: any) =>
                                selectedIds.includes(getUniqueIdByTabIndex(item, tabIndex))
                            )
                        }
                        onChange={(e) =>
                            handleSelectAllEmployed(items?.data?.data || [], e.target.checked)
                        }
                    />,
                    'CUIL',
                    'Nombre y Apellido',
                    'Localidad',
                    'Contrato',
                    'Inicio Contrato',
                    'Riesgo',
                    ...(tabIndex === 1 ? ['Exámen Asignado'] : []),
                    ...(tabIndex === 2 || tabIndex === 3 ? ['Prestador'] : []),
                    ...(tabIndex === 3 ? ['Estado'] : []),
                    'Acciones'
                ]}
                columnWidths={getColumnWidths(tabIndex)}
                items={items}
                filters={filters}
                setFilters={setFilters}
                isFetching={isFetching}
                selected={items?.id}
                selectedItemFromAction={3}
                noInfoImage={NoTableDataImageBO}
                headers={[
                    {
                        type: 'data',
                        upperLabel: (item: any) => (
                            <Checkbox
                                checked={selectedIds.includes(
                                    getUniqueIdByTabIndex(item, tabIndex)
                                )}
                                onChange={() => handleSelectEmployee(item)}
                            />
                        )
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            item?.cuil ||
                            item?.empleado?.cuil ||
                            item?.examenEmpleado?.empleado?.cuil ||
                            '-'
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            `${item?.nombre || ''} ${
                                item?.apellido ||
                                item?.empleado?.nombre ||
                                item?.examenEmpleado?.empleado?.nombre ||
                                ''
                            }`
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            item?.establecimiento?.direccion?.localidad?.nombre ||
                            item?.localidad?.nombre ||
                            item?.empleado?.establecimiento?.direccion?.localidad?.nombre ||
                            item?.examenEmpleado?.empleado?.establecimiento?.direccion?.localidad
                                ?.nombre ||
                            '-'
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            `${
                                item?.organismo?.organismoCentral?.cuit ||
                                item?.organismoCentral?.cuit ||
                                item?.empleado?.organismo?.organismoCentral?.cuit ||
                                item?.examenEmpleado?.empleado?.organismo?.organismoCentral?.cuit ||
                                ''
                            }  ${
                                item?.organismo?.organismoCentral?.nombre ||
                                item?.organismoCentral?.nombre ||
                                item?.examenEmpleado?.empleado?.organismo?.organismoCentral
                                    ?.nombre ||
                                item?.empleado?.organismo?.organismoCentral?.nombre ||
                                ''
                            }`
                    },
                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            getFechaContratoBadge(
                                item?.empleado?.organismo?.organismoCentral?.fechaInicioContrato ||
                                    item?.organismo?.organismoCentral?.fechaInicioContrato ||
                                    item?.organismoCentral?.fechaInicioContrato ||
                                    item?.examenEmpleado?.empleado?.organismo?.organismoCentral
                                        ?.fechaInicioContrato
                            )
                    },

                    {
                        type: 'data',
                        upperLabel: (item: any) =>
                            `${
                                item?.riesgo?.codigo || item?.examenEmpleado?.riesgo?.codigo || ''
                            } - ${
                                item?.riesgo?.descripcion ||
                                item?.examenEmpleado?.riesgo?.descripcion ||
                                ''
                            }`
                    },

                    ...(tabIndex === 1
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) =>
                                      item?.examen?.descripcion ||
                                      item?.examenEmpleado?.examen?.descripcion ||
                                      ''
                              }
                          ]
                        : []),
                    ...(tabIndex === 2 || tabIndex === 3
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) =>
                                      item?.prestador?.razonSocial ||
                                      item?.examenEmpleado?.prestador?.razonSocial ||
                                      '-'
                              }
                          ]
                        : []),
                    ...(tabIndex === 3
                        ? [
                              {
                                  type: 'data',
                                  upperLabel: (item: any) => (
                                      <StateBadgeConvocated
                                          hideIcon
                                          state={item?.examenEmpleado?.idEstadoEmpleadoExpuesto}
                                          text={(() => {
                                              const estado = getEstadoExpuestoOptions(t).find(
                                                  (opt: any) =>
                                                      opt.id ===
                                                      item?.examenEmpleado?.idEstadoEmpleadoExpuesto
                                              );
                                              return estado?.nombre || '-';
                                          })()}
                                      />
                                  )
                              }
                          ]
                        : []),

                    {
                        type: 'action',
                        onClick: handleClickAction
                    }
                ]}
            />
        </>
    );
};

export default ExposedGrid;
